import { Grid } from "@mui/material";
import { fCoins } from "src/utils/formatNumber";
import UsersCountSummary from "../users/UsersCountSummary";

export default function ProfileUserStats({ user }) {
	return (
		<Grid container spacing={1} sx={{ mb: 6, p: 0 }}>
			<Grid item xs={2}>
				<UsersCountSummary title="IAP Purchases" total={user.purchasesCount} />
			</Grid>
			<Grid item xs={2}>
				<UsersCountSummary title="IAP Purchases Rev" total={`$${user.iapTotal}`} />
			</Grid>
			<Grid item xs={2}>
				<UsersCountSummary title="Coins Purchased" total={fCoins(user.buyCoinsTotal)} icon="/assets/icons/ufcoin.svg" />
			</Grid>
			<Grid item xs={2}>
				<UsersCountSummary title="Arcade Spent" total={fCoins(user.gameProviderEntryAmount)} icon="/assets/icons/ufcoin.svg" />
			</Grid>
			<Grid item xs={2}>
				<UsersCountSummary title="Arcade Won" total={fCoins(user.gameProviderEntryPrize)} icon="/assets/icons/ufcoin.svg" />
			</Grid>
			<Grid item xs={2}>
				<UsersCountSummary title="Arcade Profit" total={fCoins(user.gameProviderProfit)} icon="/assets/icons/ufcoin.svg" />
			</Grid>
		</Grid>
	);
}
